/* eslint-disable no-nested-ternary */

import React, { useState, useEffect, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLocation, useParams } from 'react-router-dom';
import * as yup from "yup";
import { flushSync } from 'react-dom';
import {
    TextField, Button, Box, Autocomplete, FormHelperText, FormControl, ListItemText, Checkbox, Divider, FormControlLabel, Paper, Tooltip, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Typography, CircularProgress
} from "@mui/material";

import { alpha, styled } from '@mui/material/styles';
import { Icon as Iconify } from '@iconify/react';
import LoadingProgressBar from '../../../components/loading-progressbar';
import schemedefinationService from "../../../services/schemedefination.service";
import { useSchemeStore } from '../schemeStore';
import DeletePopup from '../../../commons/DeletePopup';


const custom = ({ isSchemeTargetSubClassificationControl, searchedValue, selectedValues, setSelectedValues, setValue, ...paperProps }) => {  // NOSONAR
    const { children, ...restPaperProps } = paperProps;
    const filteredOptions = isSchemeTargetSubClassificationControl.DefaultValues.filter(item =>
        item[isSchemeTargetSubClassificationControl.DisplayExpr]?.toLowerCase()?.includes(searchedValue.toLowerCase())
    );
    const isAllFilteredSelected = selectedValues.length > 0 && filteredOptions.every(option =>
        selectedValues.some(selected => selected[isSchemeTargetSubClassificationControl.ValueExpr] === option[isSchemeTargetSubClassificationControl.ValueExpr])
    );
    return (<Paper {...restPaperProps}>
        <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>
            <FormControlLabel
                onClick={(e) => {
                    e.preventDefault();
                    if (searchedValue?.length > 0) {
                        if (isAllFilteredSelected) {
                            // Unselect filtered options
                            const newSelectedValues = selectedValues.filter(item =>
                                !filteredOptions.some(filtered => filtered[isSchemeTargetSubClassificationControl.ValueExpr] === item[isSchemeTargetSubClassificationControl.ValueExpr])
                            );
                            setSelectedValues(newSelectedValues);
                            setValue(isSchemeTargetSubClassificationControl.ValueExpr, newSelectedValues);
                        } else {
                            // Select filtered options
                            const newSelectedValues = Array.from(new Set([...selectedValues, ...filteredOptions]));
                            setSelectedValues(newSelectedValues);
                            setValue(isSchemeTargetSubClassificationControl.ValueExpr, newSelectedValues);
                        }
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (selectedValues?.length < isSchemeTargetSubClassificationControl.DefaultValues?.length) {
                            setSelectedValues(isSchemeTargetSubClassificationControl.DefaultValues);
                            setValue(isSchemeTargetSubClassificationControl.ValueExpr, isSchemeTargetSubClassificationControl.DefaultValues);
                        } else {
                            setSelectedValues([]);
                            setValue(isSchemeTargetSubClassificationControl.ValueExpr, []);
                        }
                    }
                }}
                label={
                    <span style={{ fontSize: '13px', paddingLeft: '0.7em' }}>
                        {searchedValue?.length > 0
                            ? isAllFilteredSelected  // NOSONAR
                                ? 'Unselect filtered options'
                                : 'Select filtered options'
                            : selectedValues?.length === isSchemeTargetSubClassificationControl.DefaultValues?.length  // NOSONAR
                                ? 'Unselect All'
                                : 'Select All'
                        }
                    </span>
                }
                control={
                    <Checkbox
                        size='small'
                        id="select-all-checkbox"
                        checked={isSchemeTargetSubClassificationControl.DefaultValues?.length > 0 && searchedValue?.length > 0 ? isAllFilteredSelected : selectedValues?.length === isSchemeTargetSubClassificationControl.DefaultValues?.length}
                    />
                }
            />
        </Box>
        <Divider />
        {children}
    </Paper>)
}

const custom1 = ({ isSchemeTargetSubClassificationControl, selectedValues, setSelectedValues, setValue, ...paperProps }) => {
    const { children, ...restPaperProps } = paperProps;
    return (<Paper {...restPaperProps}>

        <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>

            <FormControlLabel
                onClick={(e) => {
                    e.preventDefault(); // prevent blur

                    const allValues = isSchemeTargetSubClassificationControl.DefaultValues;

                    if (selectedValues?.length < allValues?.length) {
                        // Select all items
                        setSelectedValues(allValues);
                        setValue(isSchemeTargetSubClassificationControl.ValueExpr, isSchemeTargetSubClassificationControl.DefaultValues);
                    } else {
                        // Unselect all items
                        setSelectedValues([]);
                        setValue(isSchemeTargetSubClassificationControl.ValueExpr, []);
                    }
                }}
                label={
                    <span style={{ fontSize: '13px', paddingLeft: '0.7em' }}>
                        {selectedValues?.length === isSchemeTargetSubClassificationControl?.DefaultValues?.length ? 'Unselect All' : 'Select All'}
                    </span>
                } control={
                    <Checkbox size='small' id="select-all-checkbox" checked={isSchemeTargetSubClassificationControl.DefaultValues?.length > 0 && selectedValues?.length === isSchemeTargetSubClassificationControl.DefaultValues?.length} />
                }
            />
        </Box>
        <Divider />
        {children}
    </Paper>)
}


export default function SchemeConditional() {

    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;
    const {
        schemeDetails,
        slabFormData,
        setConditionalCriteriaData,
        updateScheme,
        tabValue,
        prevTabValue,
        addScheme,
    } = useSchemeStore();



    const textFieldRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showErrorMsg, setShowErrorMsg] = useState(false)
    const [controls, setControls] = useState([]);
    const [validationSchema, setValidationSchema] = useState(yup.object().shape({}));  // NOSONAR
    const [selectedClassification, setSelectedClassification] = useState(null); // Second Dropdown State
    const [isSchemeTargetClassificationControl, setIsSchemeTargetClassificationControl] = useState([]); // Third Dropdown State
    const [isTargetClassificationField, setIsTargetClassificationField] = useState(null); // Fouth Dropdown State
    const [isSchemeTargetSubClassificationControl, setIsSchemeTargetSubClassificationControl] = useState(null); // Fifth Dropdown State
    const [selectedValues, setSelectedValues] = useState([]);
    const [searchedValue, setSearchedValue] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [tempData, setTempData] = useState([])
    const [displayErrorMsg, setDisplayErrorMsg] = useState(null)
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const [criteriaValueValidation, setCriteriaValueValidation] = useState('')
    const [criteriaValueValidationFlag, setCriteriaValueValidationFlag] = useState(false)

    const [criteriaValueValidationSlabMsg, setCriteriaValueValidationSlabMsg] = useState('')
    const [criteriaValueValidationSlab, setCriteriaValueValidationSlab] = useState(false)

    const [slabOptionsData, setSlabOptionsData] = useState([]);
    const [AutocompleteLoadingMap, setAutocompleteLoadingMap] = useState(new Map());






    useEffect(() => {
        if (Array.isArray(slabFormData)) {
            const slabOptions = slabFormData.map(slab => ({
                SlabName: slab.SlabName,
                SlabId: slab.Id,
                SlabLifting: slab.LiftingQuantity,
            }));
            setSlabOptionsData(slabOptions);
        } else {
            setSlabOptionsData([]);
        }
    }, [slabFormData]);



    useEffect(() => {
        const initialTempData = [];
        let uniqueIdCounter = 0; // Counter for generating unique IDs

        schemeDetails?.ConditionalCriteria?.forEach((criteria) => {
            const { Slab: slabName, SlabCriteriaIn, SlabCriteriaValue, Benefits, CriteriaType } = criteria;

            criteria.Filter?.forEach((filter) => {
                filter.SubClassification?.forEach((subClassification) => {
                    const combinedClassifications = []; // For combined criteria

                    subClassification.ClassificationValue?.forEach((classificationValue) => {
                        const classificationEntry = {
                            ClassificationId: classificationValue.ClassificationId,
                            Classification: classificationValue.Classification,
                            CriteriaValue: classificationValue.CriteriaValue,
                            // eslint-disable-next-line no-plusplus
                            id: `${Date.now()}-${uniqueIdCounter++}`, // Unique ID
                        };

                        if (CriteriaType === "Combined") {
                            // Store in combinedClassifications for later concatenation
                            combinedClassifications.push(classificationEntry);
                        } else {
                            // Push individual entries for Split criteria
                            initialTempData.push({
                                SlabName: slabName,
                                CriteriaValueIn: SlabCriteriaIn,
                                SlabCriteria: SlabCriteriaValue,
                                Benefits,
                                CriteriaType,
                                ClassificationOn: filter.ClassificationOn,
                                TargetClassification: subClassification.SubClassificationValue,
                                ClassificationId: classificationEntry.ClassificationId,
                                id: classificationEntry.id,
                                Classification: classificationEntry.Classification,
                                CriteriaValue: classificationEntry.CriteriaValue
                            });
                        }
                    });

                    // If the criteria type is Combined, create a single entry with concatenated names and IDs
                    if (CriteriaType === "Combined") {

                        const combinedNames = combinedClassifications.map(entry => entry.Classification).join(', ');
                        const combinedIds = combinedClassifications.map(entry => entry.ClassificationId).join(', ');

                        // Convert the string to an array and filter out empty values
                        const filteredIds = combinedIds.split(',')
                            .map(id => id.trim()) // Remove any whitespace around each ID
                            .filter(id => id); // Filter out empty strings

                        // Join the filtered IDs back into a string if needed
                        const result = filteredIds.join(', ');

                        // Log the result
                         //  console.log('combinedIds combinedIds:', combinedIds);
                         //  console.log('Filtered combinedIds:', result);


                        initialTempData.push({
                            SlabName: slabName,
                            CriteriaValueIn: SlabCriteriaIn,
                            SlabCriteria: SlabCriteriaValue,
                            Benefits,
                            CriteriaType,
                            ClassificationOn: filter.ClassificationOn,
                            TargetClassification: subClassification.SubClassificationValue,
                            ClassificationId: result, // Combined IDs
                            // eslint-disable-next-line no-plusplus
                            id: `${Date.now()}-${uniqueIdCounter++}`, // Unique ID
                            Classification: combinedNames, // Combined names
                        });
                    }
                });
            });
        });

         //  console.log('initialTempData:', initialTempData);
        setTempData(initialTempData);
    }, [schemeDetails]);



    const { id } = useParams();

    const { watch, control, handleSubmit, setValue, reset } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            SlabName: '',
            CriteriaValueIn: '',
            SlabCriteria: '',
            Benefits: '',
            CriteriaType: '',
            ClassificationOn: '',

        },

        mode: 'onChange',
    });

    const values = watch();

    /*  ---------------------- Conditional Criteria Controls -----------------------------------------------------------------------------------------   */
    // Fetch dynamic controls from API and generate validation schema
    useEffect(() => {
        schemedefinationService.then(schemeDefinationInstance => {
            schemeDefinationInstance.ConditionalCriteriaControls()
                .then((response) => {
                    if (response.status === 200) {
                        const slabOptions = Array.isArray(slabFormData)
                            ? slabFormData.map(slab => ({
                                SlabName: slab.SlabName,
                                Id: slab.Id
                            }))
                            : [];
                        setIsLoading(false);
                        const updatedControls = response.data.map(controll => {
                            if (controll.ValueExpr === "SlabName") {
                                return { ...controll, DefaultValues: slabOptions };
                            }
                            setIsLoading(false);
                            return controll;
                        });

                        setControls(updatedControls);


                        setIsLoading(false);

                    } else {
                        console.error("Failed to fetch controls.");
                        setIsLoading(false);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching controls:", err);
                    setIsLoading(false);
                });

        });

    }, [slabFormData]);

    /* ------------------Classification On Control Api ------------------------------------------------------------ */
    useEffect(() => {
        if (selectedClassification) {
            setIsLoading(true);
            schemedefinationService.then(schemeDefinationInstance => {
                schemeDefinationInstance.GetSchemeTargetClassification(selectedClassification)
                    .then((response) => {
                        setIsSchemeTargetClassificationControl(response.data);
                        setIsLoading(false);
                    })
                    .catch((error) => {
                        console.error('Error fetching third dropdown data:', error);
                        setIsLoading(false);

                    });

            });
        }

    }, [selectedClassification]);

    /* ------------- SchemeTargetSubClassification Controls---------------------------------------------------------------------------------------------------------------- */
    useEffect(() => {   // NOSONAR
        // Only proceed if isTargetClassificationField is present
        if (selectedClassification && isTargetClassificationField) {
            setIsLoading(true);
            const payload = {
                Id: id,
                TargetOn: selectedClassification,
                SchemeTargetClassification: isTargetClassificationField,
            };

            const fetchSubClassification = async () => {
                try {
                    const schemeDefinationInstance = await schemedefinationService;
                    const response = await schemeDefinationInstance.GetSchemeTargetSubClassification(payload);
                    setIsLoading(true);
                    if (response.status === 200) {

                        if (isEditing) {

                            const temp = response.data;
                             //  console.log('hii ', temp);

                            // Retrieve previous options
                            const prevOptions = isSchemeTargetSubClassificationControl?.DefaultValues;

                            // Merge prevOptions and temp.DefaultValues, keeping only unique ClassificationId values
                            const combinedOptions = [...(prevOptions || []), ...(temp.DefaultValues || [])];
                            const uniqueDefaultValues = [
                                ...combinedOptions.reduce((map, item) => {
                                    map.set(item.ClassificationId, item);
                                    return map;
                                }, new Map()).values()
                            ];

                            // Update temp with unique DefaultValues
                            const updatedData = {
                                ...temp,
                                DefaultValues: uniqueDefaultValues
                            };

                            // Set the updated data to isSchemeTargetSubClassificationControl
                            setIsSchemeTargetSubClassificationControl(updatedData);

                        }
                        else {

                            setIsSchemeTargetSubClassificationControl(response.data);
                        }
                        setIsLoading(false);

                    } else {
                         //  console.log("Error while fetching subclassification. Status:", response.status);
                         //  console.log("Error Message:", response.data);
                        setIsLoading(false);

                    }
                } catch (error) {
                     //  console.log("Error:", error);
                    setIsLoading(false);

                }
            };

             //  console.log(' isEditing ', isEditing);
             //  console.log(' selectedValues?.length ', selectedValues?.length);
             //  console.log(' selectedValues ', selectedValues);

            if ((values?.TargetClassification !== undefined && values?.TargetClassification !== null && values?.TargetClassification !== "") || isEditing) {
                 //  console.log("Condition : selectedValues is empty, calling fetchSubClassification()");
                fetchSubClassification();
            }

        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTargetClassificationField]);



    const arraysEqual = (a, b) => {
        // Log the arrays being compared
         //  console.log("Comparing arrays:", a, b);

        if (a.length !== b.length) return false;

        // Sort both arrays by ClassificationId for comparison
        const sortedA = a.map(item => item.ClassificationId).sort();
        const sortedB = b.map(item => item.ClassificationId).sort();

        const equal = sortedA.every((value, index) => value === sortedB[index]);

        // Log result of comparison
         //  console.log("Arrays equal:", equal);
        return equal;
    };


    const onSubmit = (data) => {  // NOSONAR
        if (!data.TargetClassification || !data.ClassificationId?.length) {
             //  console.log("TargetClassification is null and ClassificationId is empty.");
            return;
        }

         //  console.log("onSubmit Data:", data);

        const matchedSlab = slabOptionsData.find(slab => slab.SlabName === data.SlabName);

        if (matchedSlab && parseFloat(data.SlabCriteria) > parseFloat(matchedSlab.SlabLifting)) {
            setDisplayErrorMsg(`Slab Criteria Value (${data.SlabCriteria}) cannot be greater than Lifting Quantity (${matchedSlab.SlabLifting}) for ${data.SlabName}`);
            return;
        }

        // Skip duplicate check if in editing mode
        if (!editingId) {
            const isDuplicate = tempData.some(item => {
                const isSame =
                    item.SlabName === data.SlabName &&
                    item.CriteriaValueIn === data.CriteriaValueIn &&
                    item.SlabCriteria === data.SlabCriteria &&
                    item.Benefits === data.Benefits &&
                    item.ClassificationOn === data.ClassificationOn &&
                    item.TargetClassification === data.TargetClassification;

                let itemClassificationId;
                if (Array.isArray(item.ClassificationId)) {
                    itemClassificationId = item.ClassificationId.map(idObj => idObj.ClassificationId);
                } else if (typeof item.ClassificationId === 'string') {
                    itemClassificationId = [item.ClassificationId];
                } else {
                    itemClassificationId = [];
                }

                const dataClassificationId = Array.isArray(data.ClassificationId)
                    ? data.ClassificationId.map(idObj => idObj.ClassificationId)
                    : [data.ClassificationId];

                const classificationIdsEqual = arraysEqual(itemClassificationId, dataClassificationId);
                return isSame && classificationIdsEqual;
            });

            if (isDuplicate) {
                 //  console.log("Duplicate entry found, skipping addition.");
                return;
            }
        }

        const hasDifferentCriteriaType = tempData.some(item =>
            item.SlabName === data.SlabName && item.CriteriaType !== data.CriteriaType
        );
        if (!editingId) {
            if (hasDifferentCriteriaType) {
                setDisplayErrorMsg(`An entry with SlabName "${data?.SlabName}" already exists with a different CriteriaType.`);
                return;
            }
        }
        const updatedTempData = editingId
            ? tempData.map(item => {
                if (item.SlabName === data.SlabName) {
                    // Update SlabCriteria and Benefits for all matching SlabName entries
                    return {
                        ...item,
                        SlabCriteria: data.SlabCriteria,
                        Benefits: data.Benefits,
                    };
                }
                return item;
            })
            : [...tempData, { ...data, id: Date.now() }];


         //  console.log('updatedTempData #### ', updatedTempData);



        if (data.CriteriaType === "Split") {
            // For Split mode, create a separate row for each ClassificationId
            const newRows = data.ClassificationId.map(classification => ({
                ...data,
                id: `${Date.now()}-${classification.ClassificationId}`,
                ClassificationId: classification.ClassificationId,
                Classification: classification.Classification,
            }));

            setTempData(prevData =>
                editingId
                    ? [...updatedTempData.filter(row => row.id !== editingId), ...newRows]
                    : [...prevData, ...newRows]
            );

             //  console.log("Data after Split submission (separate rows):", newRows);

        } else if (data.CriteriaType === "Combined") {
             //  console.log('1');
            const combinedData = {
                ...data,
                id: editingId || Date.now(),
                ClassificationId: data.ClassificationId.map(c => c.ClassificationId).join(', '),
                Classification: data.ClassificationId.map(c => c.Classification).join(', '),
            };

            setTempData(prevData => editingId
                ? prevData.map(row => row.id === editingId ? { ...row, ...combinedData } : row)
                : [...prevData, combinedData]
            );

             //  console.log("Data after Combined submission:", combinedData);

        } else {
            setTempData(prevData => editingId
                ? updatedTempData.map(row => (row.id === editingId ? { ...data, id: editingId } : row))
                : [...prevData, { ...data, id: Date.now() }]
            );
        }

        // Reset form after submission
        reset();
        setEditingId(null);
        setSelectedClassification(null);
        setIsTargetClassificationField(null);
        setSelectedValues([]);
        setShowErrorMsg(false)
        setCriteriaValueValidationFlag(false)
        setCriteriaValueValidationSlab(false)
    };

    /*------------------------------------------------------------------------------------------------------------------------------*/

   

    /* ------------------------------------------- Edit ------------------------------------------------------------------------------------------- */

    const handleEditClick = async (editId) => {  // NOSONAr
        setIsEditing(true);
         //  console.log("editId:", editId);

        let rowToEdit;

        if (editId) {
             //  console.log('if string id ', editId);
            rowToEdit = tempData.find(row =>
                row.CriteriaType === "Combined"  // NOSONAR
                    ? row.id === editId
                    : row.id === editId
            );


        } else {
             //  console.log('else string id ', editId);

            rowToEdit = tempData.find(row =>
                row.CriteriaType === "Combined"
                    ? row.id === parseInt(editId, 10)
                    : row.id === editId
            );
        }


        if (!rowToEdit) {
            console.warn(`No row found with id: ${editId}`);
            return;
        }

         //  console.log('rowToEdit:', rowToEdit);

        // Populate form with existing data and log each key and value
        Object.keys(rowToEdit).forEach(key => {
            if (key !== 'ClassificationId') {
                 //  console.log(`Setting ${key} to:`, rowToEdit[key]); // Log key and value
                setValue(key, rowToEdit[key]);
            }
        });

        const { ClassificationOn, TargetClassification } = rowToEdit;
        setSelectedClassification(ClassificationOn);
        setIsTargetClassificationField(TargetClassification);


        if (rowToEdit.CriteriaType === "Split") {


            // Reset DefaultValues at the beginning to ensure accurate conditions
            const temp = { ...isSchemeTargetSubClassificationControl, DefaultValues: [] };

            if (temp?.DefaultValues?.length > 0) {
                 //  console.log('split if run ');

                const matchedValues = temp.DefaultValues.filter(
                    item => item.ClassificationId === rowToEdit.ClassificationId
                );

                 //  console.log('split if selectedValues matchedValues ', matchedValues);


                flushSync(() => {
                    setSelectedValues(matchedValues);
                    setValue('ClassificationId', matchedValues);
                });


            } else if (rowToEdit?.ClassificationId) {
                 //  console.log('split else if run ');

                const classificationIdsArray = rowToEdit.ClassificationId?.split(', ');
                const classificationsArray = rowToEdit.Classification?.split(', ');

                const matchedValues = classificationIdsArray?.map((idd, index) => ({
                    ClassificationId: idd,
                    Classification: classificationsArray[index]
                }));

                 //  console.log('split else if selectedValues matchedValues ', matchedValues);

                // Update temp with new matched values
                temp.DefaultValues = matchedValues;

                flushSync(() => {
                    setIsSchemeTargetSubClassificationControl(temp);
                    setSelectedValues(matchedValues);
                    setValue('ClassificationId', matchedValues);
                });


            }

        } else {
             //  console.log('combine else run');

            const temp = { ...isSchemeTargetSubClassificationControl, DefaultValues: [] };

            // Assuming rowToEdit.ClassificationId and rowToEdit.Classification are strings
            const classificationIdsArray = rowToEdit.ClassificationId?.split(', ');
            const classificationsArray = rowToEdit.Classification?.split(', ');

            const matchedValues = classificationIdsArray?.map((idd, index) => ({
                ClassificationId: idd,
                Classification: classificationsArray[index]
            }));

            // Log the result to verify the output
             //  console.log('combine selectedValues matchedValues ', matchedValues);

            temp.DefaultValues = matchedValues;
             //  console.log("combine temp.DefaultValues after assignment:", temp.DefaultValues);

            flushSync(() => {
                setIsSchemeTargetSubClassificationControl(temp);
                // Set the selected values
                setSelectedValues(matchedValues);
                setValue('ClassificationId', matchedValues);
            });




        }


        setEditingId(editId);
    };

    /* -------------------------------- Delete --------------------------------------------------------------------------- */
    const handleDeleteClick = (deleteId) => {
        //  console.log(" deleteId :", deleteId);

        setTempData(prevData => prevData.filter(row => row.id !== deleteId));
        if (editingId === deleteId) {
            setEditingId(null);
            setIsEditing(false);
            setValue('CriteriaValue', '');
        }
    };

    const handleDeleteAllRows = () => {
        setShowDeleteConfirmation(true);
    };

    const handleConfirmDeleteAll = (confirm) => {
        if (confirm) {
            setTempData([]);
            setValue('CriteriaValue', '');
        }
        setShowDeleteConfirmation(false);
    };


    /* -------------------------------- Criteria Values --------------------------------------------------------------------------- */

    const handleCriteriaValuesChange = (e, idd) => {
        const newValue = e.target.value;
        setTempData(prevData =>
            prevData.map(item =>
                item.id === idd ? { ...item, CriteriaValue: newValue } : item // Update CriteriaValue
            )
        );

        if (textFieldRef.current) {
            textFieldRef.current.focus();
        }
    };

    useEffect(() => {
         //  console.log('Values Typing : ', values);
    }, [values]);



    const StyledTable = styled(Table)(({ theme }) => ({
        borderTop: `1px solid rgba(158, 158, 158, 0.3)`,


        '& .MuiTableHead-root': {
            backgroundColor: 'white',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '13px',
            height: '48px',
            lineHeight: '40px',
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
            position: 'sticky',
            top: 0,
            zIndex: 1,
        },
        '& .MuiTableCell-root': {
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
            fontSize: '13px',
            padding: '0px 16px', // Adjust cell padding to reduce row height
            whiteSpace: 'nowrap'
        },
        '& .MuiTableRow-root': {
            minHeight: '40px',
            maxHeight: '40px',
            '&:hover': {
                backgroundColor: 'white',
            },
        }
    }));

    // Custom styled table cell
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        color: 'black',
        padding: '4px 16px', // Adjust padding
        backgroundColor: 'white',
        fontSize: '13px',
        height: '40px',
        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
        '&:first-of-type': {
            textAlign: 'left',
            paddingLeft: '0px', // Remove left padding for first column
        },
    }));

    // Custom styled table row
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
        minHeight: '80px', // Consistent row height
        '&:hover': {
            backgroundColor: 'white',
        },
    }));

    /* ----------------------------------------- Collect All Data From Grid ----------------------------------------------------------------------------- */


    useEffect(() => {
        if (prevTabValue.name === 'Conditional Criteria') {
            saveData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);


    const saveData = async () => {  // NOSONAR
        try {

           
             //  console.log('1 tempData ', tempData);

            // Check if all 'Split' criteria values are valid
            const isSplitValid = tempData.every(item =>
                item.CriteriaType === 'Split' ? item.CriteriaValue : true
            );
             //  console.log('kay : ', isSplitValid);
             //  console.log('2 tempData ', tempData);

            // Only check conditions if tempData is not empty
            if (tempData.length > 0 && isSplitValid === false) {
                
                setConditionalCriteriaData('error');
                 //  console.log(`error check1`);


                setCriteriaValueValidation('Criteria Value Required.');
                return;
            } setCriteriaValueValidation(''); // Clear error if valid




            // Validation to ensure Criteria Value sum for each SlabName does not exceed SlabLifting
            const isValid = slabOptionsData?.every(slab => {
                const totalCriteriaValue = tempData
                    .filter(item => item.SlabName === slab.SlabName)
                    .reduce((sum, item) => sum + Number(item.CriteriaValue || 0), 0);

                // Get the SlabCriteria for the current slab from tempData
                const slabCriteria = tempData?.find(item => item?.SlabName === slab?.SlabName)?.SlabCriteria;

                if (totalCriteriaValue > slabCriteria) {

                     //  console.log(`Total Criteria Value for ${slab?.SlabName} is ${totalCriteriaValue}  exceeds its Slab Criteria Value of ${slabCriteria}.`);
                    
                    setConditionalCriteriaData('error');
                     //  console.log(`error check2`);


                    setCriteriaValueValidationSlabMsg(`Total Criteria Value is ${totalCriteriaValue} exceeds its Slab Criteria Value of ${slabCriteria}.`);
                    return false; // Validation fails for this slab
                } setCriteriaValueValidationSlabMsg('')
                return true; // Validation passes for this slab
            });

             //  console.log("isValid: ", isValid);
            if (!isValid) return;

            const transformData = (tempDataa, slabOptionss) => {
                const groupedData = tempDataa.reduce((acc, item) => {
                    const {
                        SlabName,
                        CriteriaType,
                        ClassificationOn,
                        TargetClassification,
                        ClassificationId,
                        Classification,
                        CriteriaValue,
                        CriteriaValueIn
                    } = item;

                    const matchedSlab = slabOptionss.find(slab => slab.SlabName === SlabName);
                    if (!matchedSlab) return acc;

                    // Create a new entry for each slab regardless of CriteriaType
                    let slabEntry = acc.find(entry => entry.Slab === SlabName && entry.CriteriaType === CriteriaType);
                    if (!slabEntry) {
                        slabEntry = {
                            Slab: SlabName,
                            SlabId: matchedSlab.SlabId,
                            SlabLifting: matchedSlab.SlabLifting,
                            SlabCriteriaIn: item.CriteriaValueIn,
                            SlabCriteriaValue: item.SlabCriteria,
                            Benefits: item.Benefits,
                            CriteriaType,
                            Filter: []
                        };
                        acc.push(slabEntry);
                    }

                    // Group by ClassificationOn
                    let classificationEntry = slabEntry.Filter.find(filter => filter.ClassificationOn === ClassificationOn);
                    if (!classificationEntry) {
                        classificationEntry = { ClassificationOn, SubClassification: [] };
                        slabEntry.Filter.push(classificationEntry);
                    }

                    // Group by SubClassificationValue
                    let subClassificationEntry = classificationEntry.SubClassification.find(sub => sub.SubClassificationValue === TargetClassification);
                    if (!subClassificationEntry) {
                        subClassificationEntry = { SubClassificationValue: TargetClassification, ClassificationValue: [] };
                        classificationEntry.SubClassification.push(subClassificationEntry);
                    }

                    // Split ClassificationId and Classification if CriteriaValueIn is "combine"
                    if (CriteriaValueIn === "combine" || CriteriaType === "Combined") {
                        const classificationIds = ClassificationId.split(', ');
                        const classifications = Classification.split(', ');

                        classificationIds.forEach((iddd, index) => {
                            subClassificationEntry.ClassificationValue.push({
                                ClassificationId: iddd,
                                Classification: classifications[index] || "", // Fallback to empty if index is out of bounds
                                CriteriaValue: CriteriaValue || item.SlabCriteria || "0" // Default to "0" if CriteriaValues is undefined
                            });
                        });
                    } else {
                        // Add classification values normally
                        subClassificationEntry.ClassificationValue.push({
                            ClassificationId,
                            Classification,
                            CriteriaValue: CriteriaValue || "0" // Default to "0" if CriteriaValues is undefined
                        });
                    }

                    return acc;
                }, []);

                 //  console.log('here save data ', groupedData)

                return { ConditionalCriteria: groupedData };
            };


            // Get the transformed data
             //  console.log("tempData !!: ", tempData);
            const transformedData = transformData(tempData, slabOptionsData);
             //  console.log("transformedData !!: ", transformedData);

            if (Array.isArray(transformedData.ConditionalCriteria) && transformedData.ConditionalCriteria.length > 0) {

                setConditionalCriteriaData(transformedData.ConditionalCriteria);

            } else if (tempData?.length > 0) {

                setConditionalCriteriaData('error');
                 //  console.log(`error check3`);

            } else {
                setConditionalCriteriaData(null);

            }


            
            if (prevTabValue.name !== 'Conditional Criteria') {
                try {
                    if (isCopyScheme) {
                        const result = await addScheme();  // NOSONAR
                    } else {

                        const result = await updateScheme(); // NOSONAR
                    }
                } catch (err) {
                    // handle error
                }
            }

        } catch (err) {
             //  console.log("Err: ", err);
           
            setConditionalCriteriaData('error');
             //  console.log(`error check4`);

        }
    }






    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, flexGrow: 1 }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', display: 'flex', flexDirection: 'column', minHeight: 0, flexGrow: 1 }}>
                <style>
                    {`.css-1bwccnt-MuiFormLabel-root-MuiInputLabel-root.Mui-error { color: #757575;} 
                    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline { border-color: #e8e8e8 !important; }
                    .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline { border-color: #424242 !important; }
                    .css-1d1wxla-MuiFormLabel-root-MuiInputLabel-root.Mui-error {color: #757575;}
                    `}
                </style>
                <Box sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minHeight: 0,
                    // overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '6px', // Set the width of the scrollbar
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#888', // Color of the scrollbar thumb
                        borderRadius: '10px', // Rounded corners for the scrollbar thumb
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555', // Color when hovered
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1', // Color of the scrollbar track
                    },

                }}>
                    <Box
                        sx={{
                            flex: 0.8,
                            overflowY: 'auto',
                            // border: '2px solid red',
                            flexGrow: 1,
                            minHeight: 0
                        }}
                    >

                        <Box rowGap={1}
                            columnGap={2}
                            display="grid"
                            gridTemplateColumns={{
                                xs: 'repeat(1, 1fr)',
                                sm: 'repeat(3, 1fr)',
                                md: 'repeat(4, 1fr)',
                                lg: 'repeat(4, 1fr)',
                                xl: 'repeat(4, 1fr)'

                            }}
                            gridAutoRows="min-content"
                            sx={{ mt: 1 }}
                        >
                            {controls?.length > 0 &&
                                controls.map((controlData) => {   // NOSONAR
                                    const { LabelName, DataType, DefaultValues, DisplayExpr, ValueExpr } = controlData;

                                    switch (DataType) {
                                        case "Textbox":
                                            return (

                                                <Controller
                                                    key={ValueExpr}
                                                    name={ValueExpr}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                label={<>{LabelName}{controlData.Validations?.some(v => v.ValidationType === 'Required') && (<span style={{ color: 'red' }}> *</span>)}</>}
                                                                fullWidth
                                                                size='small'
                                                                sx={{
                                                                    '& .MuiFormHelperText-root.Mui-error': { color: 'red' },
                                                                    '& .MuiInputBase-input': { fontSize: '13px' },
                                                                    '& .MuiFormLabel-root': { fontSize: '14px' },
                                                                }}
                                                            />
                                                            {showErrorMsg &&
                                                                controlData.Validations?.some((v) => v.ValidationType === 'Required') &&
                                                                !values[ValueExpr] && (
                                                                    <span style={{ color: 'red', fontSize: '10px' }}>
                                                                        {controlData.Validations[0]?.ValidationMessage || 'This field is required'}
                                                                    </span>
                                                                )}

                                                        </div>
                                                    )}
                                                />

                                            );
                                        case "Dropdown":
                                            return (

                                                <Controller
                                                    key={ValueExpr}
                                                    name={ValueExpr}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <div>
                                                            <Autocomplete
                                                                options={DefaultValues || []}
                                                                getOptionLabel={(option) => option[DisplayExpr] || ""}
                                                                isOptionEqualToValue={(option, value) => option[ValueExpr] === value}
                                                                value={field.value && DefaultValues?.find((item) => item[ValueExpr] === field.value) || null}
                                                                onChange={(event, value, reason) => {
                                                                    if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                                        field.onChange(value ? value[ValueExpr] : null);
                                                                        if (ValueExpr === "ClassificationOn") {
                                                                            setSelectedClassification(value ? value[ValueExpr] : null); // Trigger third dropdown fetch
                                                                            setIsSchemeTargetClassificationControl([]);
                                                                            setIsTargetClassificationField(null);
                                                                            setValue('TargetClassification', null);
                                                                            setSelectedValues([]);
                                                                        }
                                                                    }

                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={<>{LabelName}{controlData.Validations?.some(v => v.ValidationType === 'Required') && (<span style={{ color: 'red' }}> *</span>)}</>}
                                                                        fullWidth
                                                                        size='small'
                                                                        sx={{
                                                                            '& .MuiFormHelperText-root.Mui-error': { color: 'red' },
                                                                            '& .MuiInputBase-input': { fontSize: '13px' },
                                                                            '& .MuiFormLabel-root': { fontSize: '14px' },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {showErrorMsg &&
                                                                controlData.Validations?.some((v) => v.ValidationType === 'Required') &&
                                                                !values[ValueExpr] && (
                                                                    <span style={{ color: 'red', fontSize: '10px' }}>
                                                                        {controlData.Validations[0]?.ValidationMessage || 'This field is required'}
                                                                    </span>
                                                                )}
                                                        </div>
                                                    )}

                                                />


                                            );
                                        default:
                                            return null;
                                    }
                                })
                            }

                            {selectedClassification && isSchemeTargetClassificationControl?.length > 0 && (
                                <Controller
                                    name={isSchemeTargetClassificationControl[0]?.ValueExpr}
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <Autocomplete
                                                options={isSchemeTargetClassificationControl[0]?.DefaultValues || []}
                                                getOptionLabel={(option) =>
                                                    option[isSchemeTargetClassificationControl[0]?.DisplayExpr] || ""
                                                }
                                                value={
                                                    isSchemeTargetClassificationControl[0]?.DefaultValues.find((item) => item[isSchemeTargetClassificationControl[0]?.ValueExpr] === values[isSchemeTargetClassificationControl[0]?.ValueExpr])
                                                }
                                                onChange={(event, value, reason) => {
                                                    if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                        const newValue = value ? value[isSchemeTargetClassificationControl[0]?.ValueExpr] : null;
                                                        field.onChange(newValue); // Update the form field with the new value
                                                        setIsTargetClassificationField(newValue); // Update the classification field, clear if null                                                   
                                                        setSelectedValues([]);
                                                        setIsSchemeTargetSubClassificationControl(null);
                                                        //  console.log('Target Classification:', newValue);
                                                        setValue(isSchemeTargetClassificationControl[0]?.ValueExpr, newValue)
                                                        setSearchedValue('');
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={
                                                            <>
                                                                {isSchemeTargetClassificationControl[0]?.LabelName}
                                                                {isSchemeTargetClassificationControl[0]?.Validations?.some(v => v.ValidationType === 'Required') && (
                                                                    <span style={{ color: 'red' }}> *</span>
                                                                )}
                                                            </>
                                                        }

                                                        fullWidth
                                                        size="small"
                                                        sx={{
                                                            '& .MuiFormHelperText-root.Mui-error': { color: 'red' },
                                                            '& .MuiInputBase-input': { fontSize: '13px' },
                                                            '& .MuiFormLabel-root': { fontSize: '14px' },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {showErrorMsg && !values[isSchemeTargetClassificationControl?.ValueExpr] && !values.TargetClassification &&
                                                isSchemeTargetClassificationControl[0]?.Validations[0].ValidationType === 'Required' && (
                                                    <FormHelperText style={{ color: 'red', fontSize: '10px' }}>{isSchemeTargetClassificationControl[0]?.Validations[0].ValidationMessage}</FormHelperText>
                                                )}
                                        </div>
                                    )}
                                />
                            )}

                            {selectedClassification && values?.TargetClassification && values?.TargetClassification !== null &&
                                isSchemeTargetSubClassificationControl && isSchemeTargetSubClassificationControl.DataType === 'MultiselectDropdown' && (
                                    <FormControl fullWidth>
                                        <style>
                                            {`.css-pwhq7a-MuiTypography-root {font-size: 13px;}`}

                                        </style>
                                        <Autocomplete
                                            multiple
                                            size='small'
                                            value={selectedValues}

                                            onChange={(event, newValue, reason) => {
                                                if (!(reason === 'removeOption' && event.type === 'keydown')) {

                                                    // Count occurrences of each ClassificationId
                                                    const counts = new Map();
                                                    newValue.forEach(item => {
                                                        counts.set(item[isSchemeTargetSubClassificationControl.ValueExpr], (counts.get(item[isSchemeTargetSubClassificationControl.ValueExpr]) || 0) + 1);
                                                    });

                                                    // Remove items that appear twice (they were previously selected)
                                                    const filteredValues = newValue.filter(item => counts.get(item[isSchemeTargetSubClassificationControl.ValueExpr]) === 1);


                                                    setSelectedValues(filteredValues);
                                                    setValue(isSchemeTargetSubClassificationControl.ValueExpr, filteredValues);
                                                }
                                            }}


                                            options={isSchemeTargetSubClassificationControl.DefaultValues || []}
                                            getOptionLabel={(option) => option[isSchemeTargetSubClassificationControl.DisplayExpr] || option[isSchemeTargetSubClassificationControl.ValueExpr]}
                                            renderInput={(params) => (

                                                <Tooltip
                                                    title={
                                                        <div
                                                            style={{
                                                                maxHeight: '150px',
                                                                overflowY: selectedValues?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: '#9e9e9e',
                                                                    fontSize: '12px',
                                                                    fontWeight: '300',
                                                                }}
                                                            >
                                                                {selectedValues?.map(item => item?.Classification).join(', ')}

                                                            </span>
                                                        </div>
                                                    }
                                                    arrow
                                                    placement="top"
                                                    PopperProps={{
                                                        sx: {
                                                            '& .MuiTooltip-tooltip': {
                                                                backgroundColor: 'white', // White background
                                                                color: 'black', // Black text
                                                                border: '1px solid #ccc', // Optional: subtle border for better visibility
                                                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',

                                                            },
                                                            '& .MuiTooltip-arrow': {
                                                                color: 'white', // Match the arrow color with the tooltip background
                                                            },
                                                            display: selectedValues?.length === 0 || selectedValues === null || selectedValues === undefined ? 'none' : ''
                                                        },
                                                    }}
                                                >
                                                    <TextField
                                                        {...params}
                                                        label={<>
                                                            {isSchemeTargetSubClassificationControl?.LabelName}
                                                            {isSchemeTargetSubClassificationControl?.Validations?.some(v => v.ValidationType === 'Required') &&
                                                                (<span style={{ color: 'red' }}> *</span>)
                                                            }
                                                        </>}
                                                        value={searchedValue}
                                                        onChange={e => setSearchedValue(e.target.value)}
                                                        variant="outlined"
                                                        size='small'
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '13px',  // Set text size to 13px
                                                            },
                                                            '& .MuiFormLabel-root': {
                                                                fontSize: '14px',  // Set label text size to 14px
                                                            },
                                                        }}

                                                    />
                                                </Tooltip>
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                <span style={{ fontSize: '13px', paddingLeft: '0.5em' }}>{`${value?.length} item${value?.length !== 1 ? 's' : ''} selected`}</span>
                                            }

                                            slots={{ paper: custom }}
                                            slotProps={{ paper: { isSchemeTargetSubClassificationControl, searchedValue, selectedValues, setSelectedValues, setValue } }}
                                            PaperComponent={custom}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props} key={option[isSchemeTargetSubClassificationControl.ValueExpr]}>
                                                    <Checkbox
                                                        size='small'
                                                        // checked={selectedValues?.length === targetSubClassification.DefaultValues?.length ? selectedValues?.length === targetSubClassification.DefaultValues?.length : selected}
                                                        checked={selectedValues.some((item) => item.ClassificationId === option.ClassificationId)}
                                                    />
                                                    <ListItemText
                                                        primary={option[isSchemeTargetSubClassificationControl.DisplayExpr] || option[isSchemeTargetSubClassificationControl.ValueExpr]}
                                                        primaryTypographyProps={{ style: { fontSize: '13px' } }}
                                                    />
                                                </li>
                                            )}


                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '224px',
                                                    '& .MuiAutocomplete-option': {
                                                        fontSize: '12px',  // Set the font size for the options
                                                    },
                                                },
                                            }}
                                            disableCloseOnSelect
                                        />
                                        {showErrorMsg && (!values.ClassificationId || values.ClassificationId?.length === 0) && (
                                            <FormHelperText style={{ color: 'red', fontSize: '10px' }}>{`${isSchemeTargetSubClassificationControl.LabelName} Required`}</FormHelperText>
                                        )}

                                    </FormControl>
                                )
                            }

                            {selectedClassification && values?.TargetClassification && values?.TargetClassification !== null &&
                                isSchemeTargetSubClassificationControl && isSchemeTargetSubClassificationControl.DataType === 'Autocomplete' && (
                                    <FormControl fullWidth size='small'>
                                        <Autocomplete
                                            multiple
                                            disableCloseOnSelect
                                            size='small'
                                            value={selectedValues || []}
                                            options={isSchemeTargetSubClassificationControl.DefaultValues || []}
                                            getOptionLabel={(option) => option.Classification}
                                            renderOption={(props, option, { selected }) => {
                                                // eslint-disable-next-line react/prop-types
                                                const { key, ...optionProps } = props;
                                                return (
                                                    <li key={key} {...optionProps} style={{ fontSize: '13px' }}>
                                                        <Checkbox
                                                            size='small'

                                                            style={{ marginRight: 8 }}
                                                            // checked={selectedValues?.includes(option)}
                                                            checked={selectedValues?.some(val => val.ClassificationId === option.ClassificationId)} //  fixed
                                                        />
                                                        {option.Classification}
                                                    </li>
                                                );
                                            }}
                                            renderTags={(selected) => {
                                                const selectedCount = selected?.length;
                                                return (
                                                    <span style={{ paddingLeft: '8px', fontSize: '13px' }}>
                                                        {selectedCount === 1
                                                            ? `${selectedCount} item selected`
                                                            : `${selectedCount} items selected`}
                                                    </span>
                                                );
                                            }}
                                            loading={AutocompleteLoadingMap.get(isSchemeTargetSubClassificationControl?.ValueExpr)}

                                            renderInput={(params) => (
                                                <Tooltip
                                                    id="tooltip-title-id"
                                                    title={
                                                        <div
                                                            style={{
                                                                maxHeight: '150px',
                                                                overflowY: selectedValues?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: '#9e9e9e',
                                                                    fontSize: '12px',
                                                                    fontWeight: '300',
                                                                }}
                                                            >
                                                                {selectedValues?.map(item => item?.Classification).join(', ')}
                                                            </span>
                                                        </div>
                                                    }
                                                    arrow
                                                    placement="top"
                                                    PopperProps={{
                                                        sx: {
                                                            '& .MuiTooltip-tooltip': {
                                                                backgroundColor: 'white', // White background
                                                                color: 'black', // Black text
                                                                border: '1px solid #ccc', // Optional: subtle border for better visibility
                                                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                            },
                                                            '& .MuiTooltip-arrow': {
                                                                color: '#f9f9f9', // Match the arrow color with the tooltip background
                                                            },
                                                            display: selectedValues?.length === 0 ? 'none' : '', // Fix conditional syntax
                                                        },
                                                    }}
                                                >



                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        label={<>
                                                            {isSchemeTargetSubClassificationControl?.LabelName}
                                                            {isSchemeTargetSubClassificationControl?.Validations?.some(v => v.ValidationType === 'Required') &&
                                                                (<span style={{ color: 'red' }}> *</span>)
                                                            }
                                                        </>}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {AutocompleteLoadingMap.get(isSchemeTargetSubClassificationControl?.ValueExpr) ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                        variant="outlined"
                                                        size='small'
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '13px',  // Set text size to 13px
                                                            },
                                                            '& .MuiFormLabel-root': {
                                                                fontSize: '14px',  // Set label text size to 14px
                                                            },
                                                        }}
                                                    />
                                                </Tooltip>

                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '224px',
                                                    '& .MuiAutocomplete-option': {
                                                        fontSize: '13px',  // Set the font size for the options
                                                    },
                                                },
                                            }}

                                            slots={{ paper: custom1 }}
                                            slotProps={{ paper: { isSchemeTargetSubClassificationControl, selectedValues, setSelectedValues, setValue } }}
                                            PaperComponent={custom1}


                                            onInputChange={(event, newInputValue) => {
                                                if (newInputValue?.length >= 3) {
                                                    const fetchAutoCompleteOptions = async () => {
                                                        try {
                                                            const payload = {
                                                                ControlId: `${isSchemeTargetSubClassificationControl.TableName}-${isSchemeTargetSubClassificationControl.DisplayExpr}`,
                                                                Values: newInputValue,
                                                                SchemeId: id
                                                            };

                                                            const schemeDefinationInstance = await schemedefinationService;
                                                            setAutocompleteLoadingMap(prev => new Map(prev).set(isSchemeTargetSubClassificationControl?.ValueExpr, true));

                                                            const response = await schemeDefinationInstance.SchemeTargetAutoComplete(payload);
                                                            setAutocompleteLoadingMap(prev => {
                                                                const newMap = new Map(prev);
                                                                newMap.delete(isSchemeTargetSubClassificationControl?.ValueExpr)
                                                                return newMap;
                                                            });
                                                            // Check if the response is successful
                                                            if (response.status === 200) {
                                                                const newOptions = response.data;

                                                                 //  console.log('newOptions : ', newOptions)

                                                                // Update state properly
                                                                setIsSchemeTargetSubClassificationControl(prevState => ({
                                                                    ...prevState,
                                                                    DefaultValues: newOptions // Assuming you want to overwrite the previous values
                                                                }));

                                                                // setLoading(false); // Stop loading on success
                                                            } else {
                                                                 //  console.log("Error while fetching subclassification. Status:", response.status);
                                                                 //  console.log("Error Message:", response.data);

                                                            }
                                                        } catch (error) {
                                                            console.error('Error fetching autocomplete options:', error);
                                                            setAutocompleteLoadingMap(prev => {
                                                                const newMap = new Map(prev);
                                                                newMap.delete(isSchemeTargetSubClassificationControl?.ValueExpr)
                                                                return newMap;
                                                            });
                                                            //  setLoading(false); // Stop loading on error
                                                        }
                                                    };

                                                    fetchAutoCompleteOptions(); // Call the async function
                                                }
                                            }}

                                        onChange={(event, newValue, reason) => {
                                            if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                // eslint-disable-next-line react/prop-types
                                                // const ids = newValue.map(item => item[Object.keys(item).find(key => key.toLowerCase().includes("id"))]);
                                                const ids = newValue;
                                                setValue(isSchemeTargetSubClassificationControl.ValueExpr, newValue);

                                                //  console.log("IDSSSS: ", ids)
                                                setSelectedValues(ids);
                                            }
                                            }}
                                            sx={{
                                                maxHeight: '35.69px'
                                            }}
                                        />

                                        {showErrorMsg && (!values.ClassificationId || values.ClassificationId?.length === 0) && (
                                            <FormHelperText style={{ color: 'red', fontSize: '10px' }}>{`${isSchemeTargetSubClassificationControl.LabelName} Required`}</FormHelperText>
                                        )}

                                    </FormControl>
                                )
                            }

                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end",
                            }}>
                            <Stack

                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                sx={{ py: 1 }}

                            >

                                {displayErrorMsg && ( // Conditionally render the error
                                    <FormHelperText sx={{ color: 'red' }}>
                                        {displayErrorMsg}
                                    </FormHelperText>
                                )}

                                <Tooltip title="Add Reward" arrow>
                                    <Button type='submit'
                                        variant='contained'
                                        onClick={() => { setShowErrorMsg(true); setDisplayErrorMsg(true) }}
                                        sx={{
                                            height: '30px',
                                            width: '31px',
                                            bgcolor: '#1badd1',
                                            borderRadius: '4px',
                                            minWidth: 'auto',
                                            fontSize: '25px',
                                            '&:hover': {
                                                bgcolor: '#1badd1',
                                            },
                                        }}
                                    >
                                        +
                                    </Button>
                                </Tooltip>

                            </Stack>
                        </Box>
                    </Box>


                    {/*  Second Child =---------------------------------------------------------------------------------------------------------------------- */}
                    {/*  Show System Generated Rewards ------------------------------------------------------------*/}



                    <Box
                        sx={{
                            flex: 0.9,
                            minHeight: 0,
                            width: "100%",
                            overflow: 'hidden',

                        }}
                    >
                        {isLoading && (<LoadingProgressBar />)}
                        {tempData && tempData?.length > 0 && (
                            <TableContainer component={Paper} sx={{ maxHeight: '200px', height: '100%', overflow: 'auto' }}>
                                <StyledTable sx={{ minWidth: 650 }}  >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Slab </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Criteria Value In </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Slab Criteria Value </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Benefits </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Criteria Type </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Classification </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> SubClassification </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Value </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Criteria Values </span> </StyledTableCell>
                                            <StyledTableCell> <span style={{ color: 'black ' }}> Edit </span> </StyledTableCell>
                                            <StyledTableCell>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <IconButton
                                                        onClick={handleDeleteAllRows} title="Delete All"
                                                        sx={{ padding: 0 }}
                                                    >
                                                        <Iconify icon="fluent:delete-32-regular" width='15px' height='15px' color="red" />
                                                    </IconButton>
                                                    <span style={{ color: 'black', marginLeft: '5px' }}> Delete </span>
                                                </div>
                                            </StyledTableCell>
                                        </StyledTableRow>

                                    </TableHead>
                                    <TableBody>
                                        {tempData.map((item) => {
                                             //  console.log('item : ', item);
                                            if (item.CriteriaType === "Split") {
                                                // For Split, create a separate row for each ClassificationId
                                                return (
                                                    <TableRow key={item.id}>
                                                        <StyledTableCell>{item.SlabName}</StyledTableCell>
                                                        <StyledTableCell >{item.CriteriaValueIn}</StyledTableCell>
                                                        <StyledTableCell align='right' >{item.SlabCriteria} </StyledTableCell>
                                                        <StyledTableCell align='right' >{item.Benefits}</StyledTableCell>
                                                        <StyledTableCell>{item.CriteriaType}</StyledTableCell>
                                                        <StyledTableCell>{item.ClassificationOn}</StyledTableCell>
                                                        <StyledTableCell>{item.TargetClassification}</StyledTableCell>
                                                        <StyledTableCell>
                                                            <span>{item.Classification}</span>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                                                                <TextField
                                                                    sx={{
                                                                        minWidth: '80px', // Minimum width
                                                                        maxWidth: '80px', // Maximum width to prevent overflow
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '30px', // Outer container height
                                                                            padding: '0', // Remove extra padding
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            fontSize: '12px', // Smaller font size
                                                                        },
                                                                    }}
                                                                    defaultValue={item?.CriteriaValue || ''} // Ensure value is a string or empty                                                        
                                                                    onBlur={(e) => {
                                                                        const inputValue = e.target.value;
                                                                        // Only allow numbers
                                                                        if (/^\d*$/.test(inputValue)) {
                                                                            handleCriteriaValuesChange(e, item.id);
                                                                            // Set focus back to the TextField after state update
                                                                            textFieldRef.current.focus();
                                                                        }
                                                                    }}
                                                                    placeholder="value"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} // Restrict to numeric input
                                                                    ref={textFieldRef}
                                                                />
                                                                {criteriaValueValidationFlag && !item?.CriteriaValue && (
                                                                    <Typography sx={{ color: 'red', fontSize: '10px', mt: 0.5 }}>
                                                                        {criteriaValueValidation}
                                                                    </Typography>
                                                                )}
                                                                {criteriaValueValidationSlab && item?.CriteriaValue && (
                                                                    <Typography sx={{ color: 'red', fontSize: '10px', mt: 0.5 }}>
                                                                        {criteriaValueValidationSlabMsg}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        </StyledTableCell>

                                                        <StyledTableCell sx={{ textAlign: 'left' }}>
                                                            <Tooltip title="Edit" arrow>
                                                                <IconButton onClick={() => handleEditClick(item.id)} sx={{ padding: 0 }}>
                                                                    <Iconify icon="material-symbols:edit-outline" width="15px" height="15px" color="#1976d2" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </StyledTableCell>
                                                        <StyledTableCell sx={{ textAlign: 'left' }}>
                                                            <Tooltip title="Delete" arrow>
                                                                <IconButton onClick={() => handleDeleteClick(item.id)} sx={{ padding: 0 }}>
                                                                    <Iconify icon="fluent:delete-32-regular" width="15px" height="15px" color="red" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </StyledTableCell>
                                                    </TableRow>
                                                );
                                            } if (item.CriteriaType === "Combined") { // NOSONAR
                                                // For Combined, display joined classifications and leave Criteria Values cell empty
                                                return (
                                                    <TableRow key={item.id}>
                                                        <StyledTableCell>{item.SlabName}</StyledTableCell>
                                                        <StyledTableCell>{item.CriteriaValueIn}</StyledTableCell>
                                                        <StyledTableCell align='right' >{item.SlabCriteria}</StyledTableCell>
                                                        <StyledTableCell align='right' >{item.Benefits}</StyledTableCell>
                                                        <StyledTableCell>{item.CriteriaType}</StyledTableCell>
                                                        <StyledTableCell>{item.ClassificationOn}</StyledTableCell>
                                                        <StyledTableCell>{item.TargetClassification}</StyledTableCell>
                                                        <StyledTableCell>
                                                            <span>
                                                                {item.Classification.split(',').map((classification, index) => (
                                                                    <div key={index}>{classification.trim()}</div>   // NOSONAR  
                                                                ))}
                                                            </span>
                                                        </StyledTableCell>

                                                        <StyledTableCell>
                                                            {/* Leave empty cell for value */}
                                                        </StyledTableCell>
                                                        <StyledTableCell sx={{ textAlign: 'left' }}>
                                                            <Tooltip title="Edit" arrow>
                                                                <IconButton onClick={() => handleEditClick(item.id)} sx={{ padding: 0 }}>
                                                                    <Iconify icon="material-symbols:edit-outline" width="15px" height="15px" color="#1976d2" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </StyledTableCell>
                                                        <StyledTableCell sx={{ textAlign: 'left' }}>
                                                            <Tooltip title="Delete" arrow>
                                                                <IconButton onClick={() => handleDeleteClick(item.id)} sx={{ padding: 0 }}>
                                                                    <Iconify icon="fluent:delete-32-regular" width="15px" height="15px" color="red" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </StyledTableCell>

                                                    </TableRow>
                                                );
                                            }
                                            return null; // Return null if neither condition matches
                                        })}
                                    </TableBody>
                                </StyledTable>
                            </TableContainer>
                        )}
                    
                    </Box>
                    {showDeleteConfirmation && (
                        <DeletePopup
                            setDeleteConfirm={setShowDeleteConfirmation}
                            confirm={handleConfirmDeleteAll}
                            title="Confirm Deletion"
                            msg="Are you sure you want to delete all rows?"
                        />
                    )}

                    {/* Divider */}
                    <Divider sx={{ mt: 2 }} />

                    {/* Save button fixed at the bottom */}
                    <Box sx={{ mt: 1 }}>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={2}
                            alignItems="center"
                            sx={{ padding: '2px' }}
                        >
                            {schemeDetails?.SchemeLock !== true && (
                                <Tooltip title="Save">
                                    <IconButton type="button" onClick={() => { setCriteriaValueValidationFlag(true); saveData(); setCriteriaValueValidationSlab(true) }} sx={{
                                        bgcolor: '#43b5a2',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        height: '30px',
                                        width: '31px',
                                        padding: '4px',
                                    }}>
                                        <Iconify icon="bx:save" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                    </Box>


                </Box>
            </form>
        </Box>
    )
}